import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Download, FileText, CheckCircle, DollarSign, X, Save, Send, CreditCard, Plus, Search, AlertCircle, Clock, XCircle } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const Clients = () => {
  const { darkMode } = useSettings();
  const [clients, setClients] = useState([]);
  const [paymentStatuses, setPaymentStatuses] = useState({});
    const [clientStats, setClientStats] = useState({
      total_clientes: 0,
      receita_total: 0,
      contratos_assinados: 0
    });
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isNewClient, setIsNewClient] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  // DOCUMENTOS_NO_CLIENTE_V10
  const [documentClient, setDocumentClient] = useState(null);
  const [clientDocuments, setClientDocuments] = useState([]);
  const [documentsLoading, setDocumentsLoading] = useState(false);
  const [searchCpf, setSearchCpf] = useState('');
  const [searchResult, setSearchResult] = useState(null);
  const [formData, setFormData] = useState({
    nome: '',
    cpf_cnpj: '',
    nome_fantasia: '',
    cnpj: '',
    rg: '',
    estado_civil: '',
    nome_pai: '',
    nome_mae: '',
    endereco: '',
    cep: '',
    email: '',
    telefone: '',
    parceiro_nome: '',
    origem_cliente: 'direto',
    foto_documento: '',
    foto_comprovante: '',
    garantia_meses: 12,
    pagamento_confirmado: false,
    valor_pago: 0,
    valor_restante: 0,
    forma_pagamento: '',
    valor_total: 0,
    numero_parcelas: 1
  });

  useEffect(() => {
    fetchClients();
  }, []);

    // CLIENTES_REAIS_POSTGRES_V2
    const fetchClients = async () => {
      try {
        const response =
          await axios.get(
            `${API_URL}/client-overview`
          );

        setClients(
          response.data?.clients || []
        );

        setClientStats(
          response.data?.stats || {
            total_clientes: 0,
            receita_total: 0,
            contratos_assinados: 0
          }
        );

        setPaymentStatuses(
          response.data?.payment_statuses ||
          { todos: [] }
        );
      } catch (error) {
        console.error(
          'Erro ao buscar clientes reais:',
          error
        );

        setClients([]);
        setClientStats({
          total_clientes: 0,
          receita_total: 0,
          contratos_assinados: 0
        });
        setPaymentStatuses({
          todos: []
        });
      } finally {
        setLoading(false);
      }
    };

  const handleEditClient = (client) => {
    setSelectedClient(client);
    setFormData({
      nome: client.nome || '',
      cpf_cnpj: client.cpf_cnpj || '',
      nome_fantasia: client.nome_fantasia || '',
      cnpj: client.cnpj || '',
      rg: client.rg || '',
      estado_civil: client.estado_civil || '',
      nome_pai: client.nome_pai || '',
      nome_mae: client.nome_mae || '',
      endereco: client.endereco || '',
      cep: client.cep || '',
      email: client.email || '',
      telefone: client.telefone || '',
      parceiro_nome: client.parceiro_nome || '',
      origem_cliente: client.origem_cliente || 'direto',
      foto_documento: client.foto_documento || '',
      foto_comprovante: client.foto_comprovante || '',
      garantia_meses: client.garantia_meses || 12,
      pagamento_confirmado: client.pagamento_confirmado || false,
      valor_pago: client.valor_pago || 0,
      valor_restante: client.valor_restante || 0,
      forma_pagamento: client.forma_pagamento || '',
      valor_total: client.valor_total || 0,
      numero_parcelas: client.numero_parcelas || 1
    });
    setShowModal(true);
  };

  const handleSaveContractData = async () => {
    try {
      await axios.post(`${API_URL}/leads/${selectedClient.id}/contract-data`, {
        rg: formData.rg,
        estado_civil: formData.estado_civil,
        nome_pai: formData.nome_pai,
        nome_mae: formData.nome_mae,
        endereco: formData.endereco,
        cep: formData.cep,
        foto_documento: formData.foto_documento,
        foto_comprovante: formData.foto_comprovante
      });

      await axios.put(`${API_URL}/leads/${selectedClient.id}`, {
        nome: formData.nome,
        cpf_cnpj: formData.cpf_cnpj,
        nome_fantasia: formData.nome_fantasia,
        cnpj: formData.cnpj,
        email: formData.email,
        telefone: formData.telefone,
        parceiro_nome: formData.parceiro_nome,
        origem_cliente: formData.origem_cliente,
        garantia_meses: formData.garantia_meses,
        pagamento_confirmado: formData.pagamento_confirmado ? 1 : 0,
        valor_pago: formData.valor_pago,
        valor_restante: formData.valor_restante,
        forma_pagamento: formData.forma_pagamento,
        valor_total: formData.valor_total,
        numero_parcelas: formData.numero_parcelas
      });

      setShowModal(false);
      fetchClients();
    } catch (error) {
      console.error('Erro ao salvar dados:', error);
      alert('Erro ao salvar dados do cliente');
    }
  };

  const handleConfirmPayment = async (clientId) => {
    try {
      await axios.post(`${API_URL}/leads/${clientId}/confirm-payment`);
      alert('Pagamento confirmado e contrato enviado!');
      fetchClients();
    } catch (error) {
      console.error('Erro ao confirmar pagamento:', error);
      alert('Erro ao confirmar pagamento');
    }
  };

  const handleSendContract = async (clientId) => {
    try {
      await axios.post(`${API_URL}/leads/${clientId}/send-contract`);
      alert('Contrato enviado com formas de pagamento!');
      fetchClients();
    } catch (error) {
      console.error('Erro ao enviar contrato:', error);
      alert('Erro ao enviar contrato');
    }
  };

  const handleSearchCpf = async () => {
    if (!searchCpf) return;
    try {
      const response = await axios.get(`${API_URL}/leads/search/${searchCpf}`);
      setSearchResult(response.data);
    } catch (error) {
      console.error('Erro ao buscar cliente:', error);
      setSearchResult(null);
      alert('Cliente não encontrado');
    }
  };

  const handleNewClient = () => {
    setIsNewClient(true);
    setSelectedClient(null);
    setFormData({
      nome: '',
      cpf_cnpj: '',
      nome_fantasia: '',
      cnpj: '',
      rg: '',
      estado_civil: '',
      nome_pai: '',
      nome_mae: '',
      endereco: '',
      cep: '',
      email: '',
      telefone: '',
      parceiro_nome: '',
      origem_cliente: 'direto',
      foto_documento: '',
      foto_comprovante: '',
      garantia_meses: 12,
      pagamento_confirmado: false,
      valor_pago: 0,
      valor_restante: 0,
      forma_pagamento: '',
      valor_total: 0,
      numero_parcelas: 1
    });
    setShowModal(true);
  };

  const handleCreateClient = async () => {
    try {
      const leadResponse = await axios.post(`${API_URL}/leads`, {
        nome: formData.nome,
        cpf_cnpj: formData.cpf_cnpj,
        nome_fantasia: formData.nome_fantasia,
        cnpj: formData.cnpj,
        email: formData.email,
        telefone: formData.telefone,
        parceiro_nome: formData.parceiro_nome,
        origem_cliente: formData.origem_cliente,
        garantia_meses: formData.garantia_meses,
        pagamento_confirmado: formData.pagamento_confirmado ? 1 : 0,
        valor_pago: formData.valor_pago,
        valor_restante: formData.valor_restante,
        forma_pagamento: formData.forma_pagamento,
        valor_total: formData.valor_total,
        numero_parcelas: formData.numero_parcelas,
        status: 'novo'
      });

      const leadId = leadResponse.data.id;

      await axios.post(`${API_URL}/leads/${leadId}/contract-data`, {
        rg: formData.rg,
        estado_civil: formData.estado_civil,
        nome_pai: formData.nome_pai,
        nome_mae: formData.nome_mae,
        endereco: formData.endereco,
        cep: formData.cep,
        foto_documento: formData.foto_documento,
        foto_comprovante: formData.foto_comprovante
      });

      setShowModal(false);
      fetchClients();
      alert('Cliente criado com sucesso!');
    } catch (error) {
      console.error('Erro ao criar cliente:', error);
      alert('Erro ao criar cliente');
    }
  };

  const exportToSheet = async () => {
    try {
      const response = await axios.get(`${API_URL}/leads/export/sheet?status=concluido`, {
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `clientes_${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Erro ao exportar:', error);
    }
  };

  const exportSimplified = async () => {
    try {
      const response = await axios.get(`${API_URL}/leads/export/simplified`, {
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `clientes_simplificado_${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Erro ao exportar simplificado:', error);
    }
  };


  async function abrirDocumentosCliente(registro) {
    setDocumentClient(registro);
    setClientDocuments([]);
    setDocumentsLoading(true);

    try {
      const resposta =
        await axios.get(
          API_URL +
            '/client-documents/lead/' +
            registro.id,
          {
            withCredentials: true
          }
        );

      setClientDocuments(
        resposta.data?.data || []
      );
    } catch (error) {
      window.alert(
        error.response?.data?.error ||
        'Não foi possível carregar os documentos.'
      );
    } finally {
      setDocumentsLoading(false);
    }
  }


  // CHECKLIST_DOCUMENTOS_CLIENTE_V18
  function documentoClientePorTipo(tipo) {
    return (
      clientDocuments.find(documento =>
        String(
          documento.document_type || ''
        ).toUpperCase() === tipo
      ) || null
    );
  }

  async function enviarDocumentoCliente(
    tipo,
    arquivoSelecionado
  ) {
    if (
      !documentClient?.id ||
      !arquivoSelecionado
    ) {
      return;
    }

    const formulario =
      new FormData();

    formulario.append(
      'document_type',
      tipo
    );

    formulario.append(
      'arquivo',
      arquivoSelecionado
    );

    setDocumentsLoading(true);

    try {
      await axios.post(
        API_URL +
          '/client-documents/lead/' +
          documentClient.id,
        formulario,
        {
          withCredentials: true,
          headers: {
            'Content-Type':
              'multipart/form-data'
          }
        }
      );

      await abrirDocumentosCliente(
        documentClient
      );
    } catch (error) {
      window.alert(
        error.response?.data?.error ||
        'Não foi possível enviar o documento.'
      );
    } finally {
      setDocumentsLoading(false);
    }
  }

  async function baixarDocumentoCliente(documento) {
    try {
      const resposta =
        await axios.get(
          API_URL +
            '/client-documents/' +
            documento.id +
            '/download',
          {
            responseType: 'blob',
            withCredentials: true
          }
        );

      const url =
        window.URL.createObjectURL(
          new Blob([resposta.data])
        );

      const link =
        document.createElement('a');

      link.href = url;
      link.download =
        documento.original_file_name ||
        documento.display_name ||
        'documento';

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      window.alert(
        'Não foi possível baixar o documento.'
      );
    }
  }


  // VISUALIZAR_DOCUMENTO_CLIENTE_V11
  async function visualizarDocumentoCliente(documento) {
    try {
      const resposta =
        await axios.get(
          API_URL +
            '/client-documents/' +
            documento.id +
            '/download',
          {
            responseType: 'blob',
            withCredentials: true
          }
        );

      const tipo =
        resposta.headers['content-type'] ||
        documento.mime_type ||
        documento.content_type ||
        'application/octet-stream';

      const arquivoBlob =
        new Blob(
          [resposta.data],
          {
            type: tipo
          }
        );

      const url =
        window.URL.createObjectURL(
          arquivoBlob
        );

      const novaAba =
        window.open(
          url,
          '_blank',
          'noopener,noreferrer'
        );

      if (!novaAba) {
        window.URL.revokeObjectURL(url);

        window.alert(
          'O navegador bloqueou a visualização. Permita a abertura de nova aba para este painel.'
        );

        return;
      }

      window.setTimeout(
        () => {
          window.URL.revokeObjectURL(url);
        },
        300000
      );
    } catch (error) {
      window.alert(
        error.response?.data?.error ||
        'Não foi possível visualizar o documento.'
      );
    }
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-gray-500">Carregando...</div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className={`text-3xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>Clientes</h1>
          <p className={darkMode ? 'text-gray-400' : 'text-gray-600'}>Clientes com contrato assinado e pagamento confirmado</p>
        </div>
        <div className="flex gap-3">
          <button
            onClick={handleNewClient}
            className="flex items-center gap-2 bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors"
          >
            <Plus size={20} />
            Inserir Novo Cliente
          </button>
          <button
            onClick={exportSimplified}
            className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Download size={20} />
            Download Simplificado
          </button>
          <button
            onClick={exportToSheet}
            className="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors"
          >
            <Download size={20} />
            Exportar Completo
          </button>
        </div>
      </div>

      {/* Search by CPF/CNPJ */}
      <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-xl shadow-sm p-6`}>
        <div className="flex gap-3">
          <input
            type="text"
            placeholder="Buscar por CPF/CNPJ (com ou sem traços)"
            value={searchCpf}
            onChange={(e) => setSearchCpf(e.target.value)}
            className={`flex-1 px-4 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
          />
          <button
            onClick={handleSearchCpf}
            className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Search size={20} />
            Buscar
          </button>
        </div>
        {searchResult && (
          <div className={`mt-4 p-4 rounded-lg ${darkMode ? 'bg-gray-700' : 'bg-gray-100'}`}>
            <h3 className={`font-semibold mb-2 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Resultado da Busca</h3>
            <div className={`grid grid-cols-2 gap-4 text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
              <div><strong>Nome:</strong> {searchResult.nome}</div>
              <div><strong>CPF/CNPJ:</strong> {searchResult.cpf_cnpj}</div>
              <div><strong>Data da Ação:</strong> {searchResult.data_acao ? new Date(searchResult.data_acao).toLocaleDateString('pt-BR') : '-'}</div>
              <div><strong>Garantia:</strong> {searchResult.garantia_meses} meses</div>
              <div><strong>Status:</strong> {searchResult.status}</div>
              <div><strong>Pagamento:</strong> {searchResult.pagamento_confirmado ? 'Confirmado' : 'Pendente'}</div>
            </div>
          </div>
        )}
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-xl shadow-sm p-6`}>
          <div className="flex items-center gap-4">
            <div className="bg-blue-100 p-3 rounded-lg">
              <CheckCircle className="text-blue-600" size={24} />
            </div>
            <div>
              <p className={darkMode ? 'text-gray-400 text-sm' : 'text-gray-500 text-sm'}>Total de Clientes</p>
              <p className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>{clientStats.total_clientes || 0}</p>
            </div>
          </div>
        </div>

        <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-xl shadow-sm p-6`}>
          <div className="flex items-center gap-4">
            <div className="bg-green-100 p-3 rounded-lg">
              <DollarSign className="text-green-600" size={24} />
            </div>
            <div>
              <p className={darkMode ? 'text-gray-400 text-sm' : 'text-gray-500 text-sm'}>Receita Total</p>
              <p className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                {Number(clientStats.receita_total || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              </p>
            </div>
          </div>
        </div>

        <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-xl shadow-sm p-6`}>
          <div className="flex items-center gap-4">
            <div className="bg-purple-100 p-3 rounded-lg">
              <FileText className="text-purple-600" size={24} />
            </div>
            <div>
              <p className={darkMode ? 'text-gray-400 text-sm' : 'text-gray-500 text-sm'}>Contratos Assinados</p>
              <p className={`text-2xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>{clientStats.contratos_assinados || 0}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Clients Table */}
      <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-xl shadow-sm overflow-hidden`}>
        <div className="overflow-x-auto">
            // COLUNAS_PAGAMENTO_MODO_ESCURO_V11
          <table className="w-full">
            <thead className={darkMode ? 'bg-gray-700' : 'bg-gray-50'}>
              <tr className={`text-left text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                <th className="px-6 py-3">Nome</th>
                <th className="px-6 py-3">CPF/CNPJ</th>
                <th className="px-6 py-3">Nome Fantasia</th>
                <th className="px-6 py-3">Parceiro</th>
                <th className="px-6 py-3">Pix</th>
                <th className="px-6 py-3">Cartão</th>
                <th className="px-6 py-3">Parcelado (Entrada)</th>
                <th
                  className={`px-4 py-3 text-center text-sm font-semibold border-l ${darkMode
                    ? 'bg-emerald-900/30 text-emerald-300 border-emerald-800/50'
                    : 'bg-emerald-50 text-emerald-700 border-emerald-100'
                  }`}
                >
                  Em Dia
                </th>
                <th
                  className={`px-4 py-3 text-center text-sm font-semibold border-l ${darkMode
                    ? 'bg-amber-900/30 text-amber-300 border-amber-800/50'
                    : 'bg-amber-50 text-amber-700 border-amber-100'
                  }`}
                >
                  Atrasado
                </th>
                <th
                  className={`px-4 py-3 text-center text-sm font-semibold border-l ${darkMode
                    ? 'bg-red-900/30 text-red-300 border-red-800/50'
                    : 'bg-red-50 text-red-700 border-red-100'
                  }`}
                >
                  Parou de Pagar
                </th>
                <th className="px-6 py-3">Ações</th>
              </tr>
            </thead>
            <tbody>
              {clients.map((client) => {
                const paymentStatus = paymentStatuses.todos?.find(p => p.lead_id === client.id) || {};
                return (
                  <tr key={client.id} className={`border-t ${darkMode ? 'border-gray-700 hover:bg-gray-700' : 'hover:bg-gray-50'}`}>
                    <td className={`px-6 py-4 font-medium ${darkMode ? 'text-white' : ''}`}>{client.nome}</td>
                    <td className={`px-6 py-4 ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>{client.cpf_cnpj}</td>
                    <td className={`px-6 py-4 ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>{client.nome_fantasia || '-'}</td>
                    <td className={`px-6 py-4 ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>{client.parceiro_nome || '-'}</td>
                    <td className="px-6 py-4">
                      {paymentStatus.pix_confirmado ? (
                        <span className="inline-flex items-center gap-1 text-green-600 text-sm">
                          <CheckCircle size={16} />
                          Pago
                        </span>
                      ) : client.forma_pagamento === 'pix' ? (
                        <span className="text-yellow-600 text-sm">Pendente</span>
                      ) : (
                        <span className="text-gray-400 text-sm">-</span>
                      )}
                    </td>
                    <td className="px-6 py-4">
                      {paymentStatus.cartao_confirmado ? (
                        <span className="inline-flex items-center gap-1 text-green-600 text-sm">
                          <CheckCircle size={16} />
                          Pago
                        </span>
                      ) : client.forma_pagamento?.includes('cartao') ? (
                        <span className="text-yellow-600 text-sm">Pendente</span>
                      ) : (
                        <span className="text-gray-400 text-sm">-</span>
                      )}
                    </td>
                    <td className="px-6 py-4">
                      {paymentStatus.entrada_confirmada ? (
                        <span className="inline-flex items-center gap-1 text-green-600 text-sm">
                          <CheckCircle size={16} />
                          Pago
                        </span>
                      ) : client.forma_pagamento === 'parcelado' ? (
                        <span className="text-yellow-600 text-sm">Pendente</span>
                      ) : (
                        <span className="text-gray-400 text-sm">-</span>
                      )}
                    </td>
                    <td className={`px-6 py-4 ${darkMode ? 'bg-emerald-900/30' : 'bg-emerald-50'}`}>
                      {client.forma_pagamento === 'parcelado' && paymentStatus.status_mensal === 'em_dia' ? (
                        <span className="inline-flex items-center gap-1 text-green-600 text-sm">
                          <CheckCircle size={16} />
                          Em dia
                        </span>
                      ) : (
                        <span className="text-gray-400 text-sm">-</span>
                      )}
                    </td>
                    <td className={`px-6 py-4 ${darkMode ? 'bg-amber-900/30' : 'bg-amber-50'}`}>
                      {client.forma_pagamento === 'parcelado' && paymentStatus.status_mensal === 'atrasado' ? (
                        <span className="inline-flex items-center gap-1 text-orange-600 text-sm">
                          <AlertCircle size={16} />
                          Atrasado
                        </span>
                      ) : (
                        <span className="text-gray-400 text-sm">-</span>
                      )}
                    </td>
                    <td className={`px-6 py-4 ${darkMode ? 'bg-red-900/30' : 'bg-red-50'}`}>
                      {client.forma_pagamento === 'parcelado' && paymentStatus.status_mensal === 'parou' ? (
                        <span className="inline-flex items-center gap-1 text-red-600 text-sm">
                          <XCircle size={16} />
                          Parou
                        </span>
                      ) : (
                        <span className="text-gray-400 text-sm">-</span>
                      )}
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex gap-2">
                          <button
                            onClick={() =>
                              abrirDocumentosCliente(
                                client
                              )
                            }
                            className="flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-800"
                          >
                            <FileText size={15} />
                            Documentos
                          </button>

                        <button
                          onClick={() => handleEditClient(client)}
                          className="text-blue-600 hover:text-blue-800 text-sm font-medium"
                        >
                          Editar
                        </button>
                        {!client.pagamento_confirmado && (
                          <>
                            <button
                              onClick={() => handleSendContract(client.id)}
                              className="text-green-600 hover:text-green-800 text-sm font-medium flex items-center gap-1"
                            >
                              <Send size={14} />
                              Enviar Contrato
                            </button>
                            <button
                              onClick={() => handleConfirmPayment(client.id)}
                              className="text-purple-600 hover:text-purple-800 text-sm font-medium flex items-center gap-1"
                            >
                              <CreditCard size={14} />
                              Confirmar Pagamento
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {clients.length === 0 && (
          <div className={`text-center py-12 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
            Nenhum cliente encontrado
          </div>
        )}
      </div>


        {documentClient && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
            <div className={
              'max-h-[90vh] w-full max-w-4xl overflow-y-auto rounded-xl p-6 shadow-xl ' +
              (
                darkMode
                  ? 'bg-gray-800 text-white'
                  : 'bg-white text-gray-900'
              )
            }>
              <div className="flex items-center justify-between gap-3">
                <div>
                  <h2 className="text-xl font-bold">
                    Documentos do cliente
                  </h2>

                  <p className={
                    darkMode
                      ? 'text-gray-400'
                      : 'text-gray-600'
                  }>
                    {documentClient.nome}
                  </p>

                  {documentClient.parceiro_nome && (
                    <p className="mt-1 text-sm text-blue-400">
                      Parceiro: {documentClient.parceiro_nome}
                    </p>
                  )}
                </div>

                <button
                  onClick={() =>
                    setDocumentClient(null)
                  }
                  className="rounded-lg p-2 hover:bg-gray-500/20"
                  title="Fechar"
                >
                  <X size={22} />
                </button>
              </div>

              <p className={
                'mt-5 text-sm ' +
                (
                  darkMode
                    ? 'text-gray-400'
                    : 'text-gray-600'
                )
              }>
                O visto verde indica documento anexado.
                O X vermelho indica documento pendente.
              </p>

              <div className="mt-4 grid gap-4 md:grid-cols-2">
                {[
                  ...(
                    documentClient.partner_id
                      ? [
                          {
                            tipo:
                              'FICHA_PARCEIRO_ASSINADA',
                            nome:
                              'Ficha de inscrição assinada'
                          }
                        ]
                      : []
                  ),
                  {
                    tipo:
                      'CONSULTA_SERASA',
                    nome:
                      'Consulta Serasa'
                  },
                  {
                    tipo:
                      'PROTESTOS',
                    nome:
                      'Consulta de Protestos'
                  }
                ].map(item => {
                  const documento =
                    documentoClientePorTipo(
                      item.tipo
                    );

                  return (
                    <div
                      key={item.tipo}
                      className={
                        'rounded-xl border p-4 ' +
                        (
                          documento
                            ? (
                                darkMode
                                  ? 'border-emerald-700 bg-emerald-900/20'
                                  : 'border-emerald-200 bg-emerald-50'
                              )
                            : (
                                darkMode
                                  ? 'border-red-800 bg-red-900/20'
                                  : 'border-red-200 bg-red-50'
                              )
                        )
                      }
                    >
                      <div className="flex items-start gap-3">
                        {documento ? (
                          <CheckCircle
                            size={22}
                            className="mt-0.5 shrink-0 text-emerald-500"
                          />
                        ) : (
                          <XCircle
                            size={22}
                            className="mt-0.5 shrink-0 text-red-500"
                          />
                        )}

                        <div className="min-w-0 flex-1">
                          <div className="font-semibold">
                            {item.nome}
                          </div>

                          <div className={
                            'mt-1 truncate text-sm ' +
                            (
                              darkMode
                                ? 'text-gray-400'
                                : 'text-gray-600'
                            )
                          }>
                            {documento
                              ? documento.original_file_name
                              : 'Documento não anexado'}
                          </div>
                        </div>
                      </div>

                      <div className="mt-4 flex flex-wrap gap-2">
                        <label className={
                          'cursor-pointer rounded-lg px-3 py-2 text-sm font-semibold text-white ' +
                          (
                            documento
                              ? 'bg-amber-600 hover:bg-amber-700'
                              : 'bg-green-600 hover:bg-green-700'
                          )
                        }>
                          {documento
                            ? 'Substituir'
                            : 'Anexar'}

                          <input
                            type="file"
                            accept=".pdf,.jpg,.jpeg,.png"
                            className="hidden"
                            disabled={documentsLoading}
                            onChange={event => {
                              const arquivo =
                                event.target.files?.[0] ||
                                null;

                              if (arquivo) {
                                enviarDocumentoCliente(
                                  item.tipo,
                                  arquivo
                                );
                              }

                              event.target.value = '';
                            }}
                          />
                        </label>

                        {documento && (
                          <>
                            <button
                              onClick={() =>
                                visualizarDocumentoCliente(
                                  documento
                                )
                              }
                              className="rounded-lg bg-blue-600 px-3 py-2 text-sm font-semibold text-white hover:bg-blue-700"
                            >
                              Visualizar
                            </button>

                            <button
                              onClick={() =>
                                baixarDocumentoCliente(
                                  documento
                                )
                              }
                              className={
                                'flex items-center gap-2 rounded-lg border px-3 py-2 text-sm font-semibold ' +
                                (
                                  darkMode
                                    ? 'border-gray-600 text-gray-200 hover:bg-gray-700'
                                    : 'border-gray-300 text-gray-700 hover:bg-gray-100'
                                )
                              }
                            >
                              <Download size={16} />
                              Baixar
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>

              <h3 className="mt-7 text-lg font-bold">
                Outros documentos recebidos
              </h3>

              {documentsLoading && (
                <p className="mt-4 text-gray-500">
                  Atualizando documentos...
                </p>
              )}

              <div className="mt-4 grid gap-3 sm:grid-cols-2">
                {clientDocuments
                  .filter(documento =>
                    ![
                      'FICHA_PARCEIRO_ASSINADA',
                      'CONSULTA_SERASA',
                      'PROTESTOS'
                    ].includes(
                      String(
                        documento.document_type || ''
                      ).toUpperCase()
                    )
                  )
                  .map(documento => (
                    <div
                      key={documento.id}
                      className={
                        'rounded-lg border p-4 ' +
                        (
                          darkMode
                            ? 'border-gray-700 bg-gray-900/30'
                            : 'border-gray-200 bg-gray-50'
                        )
                      }
                    >
                      <div className="flex items-center gap-2">
                        <FileText
                          size={18}
                          className="text-blue-500"
                        />

                        <span className="font-semibold">
                          {documento.display_name ||
                           documento.document_type ||
                           'Documento'}
                        </span>
                      </div>

                      <div className={
                        'mt-2 truncate text-sm ' +
                        (
                          darkMode
                            ? 'text-gray-400'
                            : 'text-gray-600'
                        )
                      }>
                        {documento.original_file_name}
                      </div>

                      <div className="mt-4 flex flex-wrap gap-2">
                        <button
                          onClick={() =>
                            visualizarDocumentoCliente(
                              documento
                            )
                          }
                          className="rounded-lg bg-blue-600 px-3 py-2 text-sm font-semibold text-white hover:bg-blue-700"
                        >
                          Visualizar
                        </button>

                        <button
                          onClick={() =>
                            baixarDocumentoCliente(
                              documento
                            )
                          }
                          className={
                            'flex items-center gap-2 rounded-lg border px-3 py-2 text-sm font-semibold ' +
                            (
                              darkMode
                                ? 'border-gray-600 text-gray-200 hover:bg-gray-700'
                                : 'border-gray-300 text-gray-700 hover:bg-gray-100'
                            )
                          }
                        >
                          <Download size={16} />
                          Baixar
                        </button>
                      </div>
                    </div>
                  ))}

                {!documentsLoading &&
                 clientDocuments.filter(documento =>
                   ![
                     'FICHA_PARCEIRO_ASSINADA',
                     'CONSULTA_SERASA',
                     'PROTESTOS'
                   ].includes(
                     String(
                       documento.document_type || ''
                     ).toUpperCase()
                   )
                 ).length === 0 && (
                  <p className={
                    darkMode
                      ? 'text-gray-400'
                      : 'text-gray-600'
                  }>
                    Nenhum outro documento recebido.
                  </p>
                )}
              </div>
            </div>
          </div>
        )}

      {/* Modal de Edição */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-xl shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto m-4`}>
            <div className="p-6 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
              <h2 className={`text-xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                {isNewClient ? 'Inserir Novo Cliente' : 'Editar Dados do Cliente'}
              </h2>
              <button
                onClick={() => setShowModal(false)}
                className={`text-gray-500 hover:text-gray-700 ${darkMode ? 'hover:text-white' : ''}`}
              >
                <X size={24} />
              </button>
            </div>
            <div className="p-6 space-y-6">
              {/* Dados Básicos */}
              <div>
                <h3 className={`text-lg font-semibold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Dados Básicos</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Nome Completo</label>
                    <input
                      type="text"
                      value={formData.nome}
                      onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    />
                  </div>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>CPF</label>
                    <input
                      type="text"
                      value={formData.cpf_cnpj}
                      onChange={(e) => setFormData({ ...formData, cpf_cnpj: e.target.value })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    />
                  </div>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Nome Fantasia</label>
                    <input
                      type="text"
                      value={formData.nome_fantasia}
                      onChange={(e) => setFormData({ ...formData, nome_fantasia: e.target.value })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    />
                  </div>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>CNPJ</label>
                    <input
                      type="text"
                      value={formData.cnpj}
                      onChange={(e) => setFormData({ ...formData, cnpj: e.target.value })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    />
                  </div>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>E-mail</label>
                    <input
                      type="email"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    />
                  </div>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Telefone</label>
                    <input
                      type="text"
                      value={formData.telefone}
                      onChange={(e) => setFormData({ ...formData, telefone: e.target.value })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    />
                  </div>
                </div>
              </div>

              {/* Dados do Contrato */}
              <div>
                <h3 className={`text-lg font-semibold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Dados do Contrato</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>RG</label>
                    <input
                      type="text"
                      value={formData.rg}
                      onChange={(e) => setFormData({ ...formData, rg: e.target.value })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    />
                  </div>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Estado Civil</label>
                    <select
                      value={formData.estado_civil}
                      onChange={(e) => setFormData({ ...formData, estado_civil: e.target.value })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    >
                      <option value="">Selecione</option>
                      <option value="solteiro">Solteiro(a)</option>
                      <option value="casado">Casado(a)</option>
                      <option value="divorciado">Divorciado(a)</option>
                      <option value="viuvo">Viúvo(a)</option>
                      <option value="uniao_estavel">União Estável</option>
                    </select>
                  </div>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Nome do Pai</label>
                    <input
                      type="text"
                      value={formData.nome_pai}
                      onChange={(e) => setFormData({ ...formData, nome_pai: e.target.value })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    />
                  </div>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Nome da Mãe</label>
                    <input
                      type="text"
                      value={formData.nome_mae}
                      onChange={(e) => setFormData({ ...formData, nome_mae: e.target.value })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    />
                  </div>
                  <div className="md:col-span-2">
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Endereço Completo</label>
                    <input
                      type="text"
                      value={formData.endereco}
                      onChange={(e) => setFormData({ ...formData, endereco: e.target.value })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    />
                  </div>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>CEP</label>
                    <input
                      type="text"
                      value={formData.cep}
                      onChange={(e) => setFormData({ ...formData, cep: e.target.value })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    />
                  </div>
                </div>
              </div>

              {/* Origem do Cliente */}
              <div>
                <h3 className={`text-lg font-semibold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Origem do Cliente</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Origem</label>
                    <select
                      value={formData.origem_cliente}
                      onChange={(e) => setFormData({ ...formData, origem_cliente: e.target.value })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    >
                      <option value="direto">Direto</option>
                      <option value="parceiro">Parceiro</option>
                    </select>
                  </div>
                  {formData.origem_cliente === 'parceiro' && (
                    <div>
                      <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Nome do Parceiro</label>
                      <input
                        type="text"
                        value={formData.parceiro_nome}
                        onChange={(e) => setFormData({ ...formData, parceiro_nome: e.target.value })}
                        className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                      />
                    </div>
                  )}
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Período de Garantia (meses)</label>
                    <input
                      type="number"
                      value={formData.garantia_meses}
                      onChange={(e) => setFormData({ ...formData, garantia_meses: parseInt(e.target.value) || 12 })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                      min="1"
                    />
                  </div>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Pagamento Confirmado</label>
                    <select
                      value={formData.pagamento_confirmado ? '1' : '0'}
                      onChange={(e) => setFormData({ ...formData, pagamento_confirmado: e.target.value === '1' })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    >
                      <option value="0">Não</option>
                      <option value="1">Sim</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Informações de Pagamento */}
              <div>
                <h3 className={`text-lg font-semibold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Informações de Pagamento</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Valor Total (R$)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={formData.valor_total}
                      onChange={(e) => setFormData({ ...formData, valor_total: parseFloat(e.target.value) || 0 })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                      min="0"
                    />
                  </div>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Valor Pago (R$)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={formData.valor_pago}
                      onChange={(e) => setFormData({ ...formData, valor_pago: parseFloat(e.target.value) || 0 })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                      min="0"
                    />
                  </div>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Valor Restante (R$)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={formData.valor_restante}
                      onChange={(e) => setFormData({ ...formData, valor_restante: parseFloat(e.target.value) || 0 })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                      min="0"
                    />
                  </div>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Forma de Pagamento</label>
                    <select
                      value={formData.forma_pagamento}
                      onChange={(e) => setFormData({ ...formData, forma_pagamento: e.target.value })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                    >
                      <option value="">Selecione</option>
                      <option value="pix">PIX</option>
                      <option value="boleto">Boleto</option>
                      <option value="cartao_credito">Cartão de Crédito</option>
                      <option value="cartao_debito">Cartão de Débito</option>
                      <option value="transferencia">Transferência Bancária</option>
                      <option value="dinheiro">Dinheiro</option>
                      <option value="parcelado">Parcelado</option>
                    </select>
                  </div>
                  {formData.forma_pagamento === 'parcelado' && (
                    <div>
                      <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Número de Parcelas</label>
                      <input
                        type="number"
                        value={formData.numero_parcelas}
                        onChange={(e) => setFormData({ ...formData, numero_parcelas: parseInt(e.target.value) || 1 })}
                        className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                        min="2"
                        max="24"
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* Documentos */}
              <div>
                <h3 className={`text-lg font-semibold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Documentos</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Foto do Documento (URL)</label>
                    <input
                      type="text"
                      value={formData.foto_documento}
                      onChange={(e) => setFormData({ ...formData, foto_documento: e.target.value })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                      placeholder="https://..."
                    />
                  </div>
                  <div>
                    <label className={`block text-sm font-medium mb-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Foto Comprovante Endereço (URL)</label>
                    <input
                      type="text"
                      value={formData.foto_comprovante}
                      onChange={(e) => setFormData({ ...formData, foto_comprovante: e.target.value })}
                      className={`w-full px-3 py-2 border rounded-lg ${darkMode ? 'bg-gray-700 border-gray-600 text-white' : 'border-gray-300'}`}
                      placeholder="https://..."
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-3">
              <button
                onClick={() => setShowModal(false)}
                className={`px-4 py-2 rounded-lg ${darkMode ? 'bg-gray-700 text-white hover:bg-gray-600' : 'bg-gray-200 text-gray-800 hover:bg-gray-300'}`}
              >
                Cancelar
              </button>
              <button
                onClick={isNewClient ? handleCreateClient : handleSaveContractData}
                className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
              >
                <Save size={20} />
                {isNewClient ? 'Criar Cliente' : 'Salvar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Clients;
